import React from 'react';
import TextInput from './text-input';

const getNumberProps = (props: NumberInputProps) =>
  ['min', 'max', 'step'].reduce(
    (result, key) =>
      props[key] !== undefined ? { ...result, [key]: props[key] } : result,
    {}
  );

const NumberInput = (props: NumberInputProps) => (
  <TextInput
    type="number"
    customInputProps={getNumberProps(props)}
    {...props}
  />
);

type NumberInputProps = {
  name: string;
  defaultValue?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled?: boolean;
  placeholder?: string;
  tabIndex?: number;
  helper?: string;
  warning?: boolean;
  children?: React.ReactNode;
  className?: string;
  inputRef: React.RefObject<HTMLInputElement>;
  required?: boolean;
  min: number;
  max: number;
  step: number;
};

NumberInput.defaultProps = {
  label: null,
  defaultValue: undefined,
  onChange: () => {},
  disabled: false,
  placeholder: null,
  tabIndex: '0',
  helper: null,
  warning: false,
  className: null,
  children: null,
  inputRef: undefined,
  required: false,
  min: undefined,
  max: undefined,
  step: undefined,
};

export default NumberInput;
